// Translation hook for UI-kit components. The app (W1.web-frame) provides `createTranslator(...).t` from @skm/i18n.
import { createContext, useContext } from 'react';

export type TFn = (key: string, params?: Record<string, string | number>) => string;

/** Default: echo the key, so an un-wrapped component still renders something testable. */
export const UiI18nContext = createContext<TFn>((key) => key);

export function useT(): TFn {
  return useContext(UiI18nContext);
}
